import { InputText } from "primereact/inputtext";
import { classNames } from "primereact/utils";
import { useTranslation } from "react-i18next";
import { Controller, useForm} from 'react-hook-form';
import { Button } from "primereact/button";
import { useEffect, useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Panel } from "primereact/panel";
import React from "react";
import { Dropdown } from "primereact/dropdown";
import getTipoResultadoMotorCredito from "../../service/getTipoResultadoMotorCredito";
import { InputNumber } from "primereact/inputnumber";

export default function ResuldadoMotorCreditoCadastrar({msgs, resultadoMotorCredito, onClose, onSave}:{msgs:any, resultadoMotorCredito:any, onClose: () => void, onSave: (resultadoMotorCredito:any) => void}) {
  const { t } = useTranslation();
  const [showItem, setShowItem] = useState<boolean>(false);
  const [itens, setItens] = useState<any[]>(resultadoMotorCredito?.itens);
  const [tipos, setTipos] = useState<any[]>();
  const [nome, setNome] = useState<string>();
  const [valorSugerido, setValorSugerido] = useState<number|null>();
  const [pontuacaoInicial, setPontuacaoInicial] = useState<string>();
  const [pontuacaoFinal, setPontuacaoFinal] = useState<string>();
  const [selectedTipo, setSelectedTipo] = useState<any>();
  const [itemEdit, setItemEdit] = useState<any>();
  const defaultValues = {
    nome: ''
  };
  defaultValues.nome = resultadoMotorCredito.nome ? resultadoMotorCredito.nome.toString() : ''
 
 
  
  const {
      control,
      formState: { errors},
      handleSubmit
  } = useForm({ defaultValues });

  const onSubmit = (data:any) => {
      data.nome && save(data);
  };

  const salvarItem = () => {
    if(valorSugerido && pontuacaoFinal && pontuacaoInicial !== undefined  && nome && selectedTipo){
      const lista = []
      itens?.forEach((p) => lista.push(p))
      const results = itens?.filter((p) => p.pontuacaoInicial === pontuacaoInicial)
      if(results && results.length !== 0 && (!itemEdit || itemEdit.pontuacaoInicial !== pontuacaoInicial)){
        msgs.current?.clear();
        msgs.current?.show([
            { sticky: false, life: 10000, severity: 'error', summary: 'Erro', detail: 'Pontuação já existe', closable: false }
           
        ]);
        window.scrollTo(0, 0);
      }
      else{
        if(!itemEdit){
          lista.push({id: null, pontuacaoInicial:pontuacaoInicial, pontuacaoFinal:pontuacaoFinal, nome: nome, tipoResultado: selectedTipo, valorSugerido: valorSugerido})
        }
        else{
          itemEdit.pontuacaoInicial = pontuacaoInicial;
          itemEdit.pontuacaoFinal = pontuacaoFinal;
          itemEdit.nome = nome;
          itemEdit.valorSugerido = valorSugerido;
          itemEdit.tipoResultado = selectedTipo;
        }
        setItens(lista)
        setSelectedTipo(null)
        setPontuacaoInicial('')
        setPontuacaoFinal('')
        setNome('')
        setShowItem(false)
      }
    }
    else{
      msgs.current?.clear();
        msgs.current?.show([
            { sticky: false, life: 10000, severity: 'error', summary: 'Erro', detail: 'Campos obrigatórios', closable: false }
           
        ]);
        window.scrollTo(0, 0);
    }
  }
 
  const save = (data:any) => {
    const resultado = {
      id: resultadoMotorCredito.id? resultadoMotorCredito.id : undefined,
      nome:data.nome,
      itens:itens
    }
    window.scrollTo(0, 0);
    onSave(resultado);
  }
  
  const getFormErrorMessage = (name:string) => {
    type ObjectKey = keyof typeof errors;
    const error = errors[Object.keys(errors).find(k => k === name) as ObjectKey]
    return error ? <small className="p-error">{error.message}</small> : <small className="p-error">&nbsp;</small>;
  };

  const editItemBodyTemplate = (item:any) => {
    return <>
      <Button icon="pi pi-pencil" type="button" onClick={(e) => {setValorSugerido(item.valorSugerido); setPontuacaoInicial(item.pontuacaoInicial); setPontuacaoFinal(item.pontuacaoFinal); setNome(item.nome); setSelectedTipo(item.tipoResultado); setItemEdit(itens.filter((s) => s.pontuacaoInicial === item.pontuacaoInicial)[0]);  setShowItem(true);}} style={{background:'transparent', color:'gray', border: 'none'}} />
      <Button icon="pi pi-trash" type="button" onClick={() => {setItens(itens?.filter((s) => s.pontuacaoInicial !== item.pontuacaoInicial))}} style={{background:'transparent', color:'gray', border: 'none'}} />
    </>
  };

  const paginatorRight = (
    <React.Fragment>
        {!showItem && (
          <div style={{display:"flex", justifyContent:"flex-end", paddingTop:"1rem"}} className=" flex">
            <Button form='form-permission' style={{marginRight:"1rem", backgroundColor:'#183462'}} label="Adicionar Item" onClick={()=>setShowItem(true)} />
          </div>
          )
        }
          {showItem && (
            <Panel>
               
                <div className="grid">
                  <div className="col p-fluid flex flex-wrap">
                    <label htmlFor="servico" className="font-bold block mb-2 required">{t('nome')} </label>
                    <InputText value={nome} onChange={(e) => setNome(e.target.value)} />
                  </div>
                  <div className="col p-fluid flex flex-wrap">
                    <label htmlFor="valor" className="font-bold block mb-2 required">{t('pontuacaoInicial')} </label>
                    <InputText value={pontuacaoInicial} onChange={(e) => setPontuacaoInicial(e.target.value)} />
                  </div>
                </div>
                <div className="grid">
                  <div className="col p-fluid flex flex-wrap">
                    <label htmlFor="operador" className="font-bold block mb-2 required">{t('resultado')} </label>
                    <Dropdown style={{width: '50%'}} value={selectedTipo} onChange={(e) => setSelectedTipo(e.value)} options={tipos} optionLabel="label" placeholder="Selecione Operador" 
                        filter className=" md:w-14rem" />  
                  </div>
                  <div className="col p-fluid flex flex-wrap">
                    <label htmlFor="valor" className="font-bold block mb-2 required">{t('pontuacaoFinal')} </label>
                    <InputText value={pontuacaoFinal} onChange={(e) => setPontuacaoFinal(e.target.value)} />
                    
                  </div>
                </div>
                <div className="grid">
                  <div className="col">
                    <label htmlFor="valorSugerido" className="font-bold block mb-2 required">{t('valorSugerido')} </label>
                    <InputNumber value={valorSugerido} onChange={(e) => setValorSugerido(e.value)} mode="currency" currency="BRL" locale="pt-BR" />
                  </div>
                </div>
                <div style={{display:"flex", justifyContent:"flex-end", paddingTop:"1rem"}} className=" flex">
                  <Button form='form-permission' style={{marginRight:"1rem", backgroundColor:'#183462'}} label="Salvar Item" onClick={()=>salvarItem()} />
                  <Button label="Fechar" icon="pi pi-times" style={{color:'#183462'}} onClick={() => setShowItem(false)} className="p-button-text" />
                </div>
             
            
            </Panel>
          )}
          
    </React.Fragment>
    );

    const tipoBodyTemplate = (item:any) => {
      return tipos?.filter((s) => s.value === item.tipoResultado)[0]?.label
    }

    useEffect(() => {
      getTipoResultadoMotorCredito().then( (data) => setTipos(data))
    }, []) 

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="flex flex-column gap-2">
        <div>
          <div className="grid">
              <div className="col p-fluid flex flex-wrap">
                
                  <Controller
                      name="nome"
                      control={control}
                      rules={{ required: 'Nome é Obrigatório' }}
                      render={({ field, fieldState }) => (
                          <>
                              <label htmlFor={field.name} className={classNames({ 'p-error': errors.nome })}></label>
                              <span className="">
                              <div>
                                <label htmlFor="descricao" className="font-bold block mb-2 required">{t('nome')} </label>
                                <InputText style={{width:'100%'}} id={field.name} value={field.value} className={classNames({ 'p-invalid': fieldState.error })} onChange={(e) => field.onChange(e.target.value)} />
                                </div>
                              </span>
                              {getFormErrorMessage(field.name)}
                          </>
                      )}
                  />
                    
               
              </div>
              
          </div>
          <br></br>
          <DataTable size="small" paginatorRight={paginatorRight} footer={paginatorRight} value={itens} tableStyle={{ minWidth: '50rem' }}>
            <Column field="nome" header={t('faixa')}></Column>
            <Column field="pontuacaoInicial" header={t('pontuacaoInicial')}></Column>
            <Column field="pontuacaoFinal" header={t('pontuacaoFinal')}></Column>
            <Column body={tipoBodyTemplate} header={t('resultado')}></Column>
            <Column body={editItemBodyTemplate} />
          </DataTable>
       
        </div>
        <br></br>
        <br></br>
        <div style={{display:"flex", justifyContent:"flex-end", paddingTop:"1rem"}} className=" flex">
            <Button style={{marginRight:"1rem", backgroundColor:'#183462'}} label="Salvar" type="submit"   />
            <Button icon="pi pi-times" onClick={onClose} rounded outlined severity="danger" aria-label="Cancel" />
        </div> 
    </form>
    
  )
}

